import type { ErinnerungKurz } from './api'
import type { PushHinweisArt } from './push'

/** "Sa., 3. Okt. · 14:00" in der Zeitzone der Erinnerung, mit Jahr, wenn es nicht das aktuelle ist */
export function erinnerungsZeit(e: Pick<ErinnerungKurz, 'faelligAm' | 'zeitzone'>, heute = new Date()): string {
  const d = new Date(e.faelligAm)
  const jahr = (x: Date) => Number(new Intl.DateTimeFormat('de-DE', { timeZone: e.zeitzone, year: 'numeric' }).format(x))
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: e.zeitzone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    ...(jahr(d) !== jahr(heute) && { year: 'numeric' }),
  })
    .format(d)
    .replace(/,\s*(\d{2}:\d{2})$/, ' · $1')
}

/** Web-Push braucht den Schlüssel als Bytes; er kommt base64url-kodiert vom Server. */
export function schluesselBytes(base64url: string): Uint8Array<ArrayBuffer> {
  const base64 = (base64url + '='.repeat((4 - (base64url.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/')
  const roh = atob(base64)
  const bytes = new Uint8Array(new ArrayBuffer(roh.length))
  for (let i = 0; i < roh.length; i++) bytes[i] = roh.charCodeAt(i)
  return bytes
}

/** Hinweis, wenn dieses Gerät eine Erinnerung nicht per Benachrichtigung melden würde */
export function pushHinweisText(art: PushHinweisArt): string {
  return art === 'aus'
    ? 'Auf diesem Gerät sind Benachrichtigungen aus: Du bekommst zur Fälligkeit keinen Weckruf, die Erinnerung steht nur hier in der App.'
    : 'Dieses Gerät kann keine Benachrichtigungen zeigen (auf dem iPhone geht es nur, wenn meine Perlen zum Home-Bildschirm hinzugefügt ist). Die Erinnerung steht nur hier in der App.'
}
